import { ReadersCoreController } from './readers-core.controller'

function readersCore () {
  return {
    restrict: 'E',
    templateUrl: '/posts/directives/readers-core/readers-core-directive.html?$$REVISION$$',
    controller: ReadersCoreController
  }
}

export { readersCore }
